<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.438 12.688H3.063c-.76 0-1.376-.616-1.376-1.376v-8.25c0-.759.616-1.374 1.375-1.374h16.5c.76 0 1.375.615 1.375 1.375v9.624h-5.5M20.938 12.688h1.375"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M7.188 12.688a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0ZM4.438 4.438h6.875v2.75H4.436v-2.75ZM14.063 4.438h4.124v2.75h-4.125v-2.75ZM17.5 22.313a2.062 2.062 0 1 1 0-4.125h2.063v4.125H17.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.563 18.875h2.75M19.563 20.938h2.75M15.438 20.25H6.5a2.75 2.75 0 0 1-2.75-2.75v-4.813"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
